import type { ParamsValidator } from 'src/components/RouteParamsValidator.tsx';
import { ProductTypes } from '../../constants.ts';
import type { BroadcastRouteParams } from './types.ts';
import { BroadcastUrlTypes } from './types.ts';

export const validateBroadcastType: ParamsValidator<BroadcastRouteParams> = ({ broadcastType }) =>
  Object.values(BroadcastUrlTypes).includes(broadcastType);

export const getProductTypeByBroadcast = (broadcastType?: BroadcastUrlTypes) => {
  switch (broadcastType) {
    case BroadcastUrlTypes.TV:
      return ProductTypes.TV;
    case BroadcastUrlTypes.RADIO:
    default:
      return ProductTypes.RADIO;
  }
};
